import { render, staticRenderFns } from "./DashboardGraph.vue?vue&type=template&id=2d30626d&scoped=true"
import script from "./DashboardGraph.vue?vue&type=script&lang=js"
export * from "./DashboardGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d30626d",
  null
  
)

export default component.exports